import React from 'react';
import BoxButton from '@/components/FileViewer/@components/BoxButton';
import ToolbarTooltip from '@/components/FileViewer/@components/ToolbarTooltip';
import ZoomOutIcon from '@/public/icons/files/zoom_out.svg';
import ZoomInIcon from '@/public/icons/files/zoom_in.svg';
import {
  MAX_ZOOM,
  MIN_ZOOM,
} from '@/components/FileViewer/utils/viewerConstants';

interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoom,
  onZoomIn,
  onZoomOut,
}) => {
  const canZoomOut = zoom > MIN_ZOOM;
  const canZoomIn = zoom < MAX_ZOOM;

  return (
    <>
      {/* 줌 아웃 */}
      <ToolbarTooltip title="축소">
        <BoxButton
          icon={<ZoomOutIcon />}
          boxSize={48}
          iconSize={24}
          onClick={onZoomOut}
          disabled={!canZoomOut}
        />
      </ToolbarTooltip>
      {/* 줌 인 */}
      <ToolbarTooltip title="확대">
        <BoxButton
          icon={<ZoomInIcon />}
          boxSize={48}
          iconSize={24}
          onClick={onZoomIn}
          disabled={!canZoomIn}
        />
      </ToolbarTooltip>
    </>
  );
};

export default ZoomControls;
